import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { deleteMyOwnTractor } from '../../../../api/user/mutations/deleteMyOwnTractor';
import { ampli } from '../../../../ampli';

export const useDeleteMyOwnTractorMutation = () => {
  const location = useLocation();

  return useMutation(deleteMyOwnTractor, {
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '보유 트랙터 등록 실패',
        '에러가 발생한 URL': location.pathname,
      }),
  });
};
